<template>
  <div>
    <div class="t_bg">
      <div class="header">
        <div class="h_top">
          <i>
            <a href="javascript:void(0)" onclick="addBookmark(this)" title="收藏本站">收藏本站</a>|
            <router-link tag="a" :to="{ name: 'about', params: { id: 3,nid:8 }}">关于威遥</router-link>|
            <router-link tag="a" :to="{ name: 'about', params: { id: 4,nid:9 }}">联系我们</router-link>
          </i>
          <div id="site">
            <div id="siteDiv">
              <ul></ul>
            </div>
          </div>欢迎来到上海威遥焊接器材有限公司
        </div>
        <div class="h_con">
          <h1>
            <router-link tag="a" :to="{name: 'home'}">
              <img :src="logo" alt="威遥焊接" title="威遥焊接" />
            </router-link>
          </h1>
          <p style="display:none;">
            <span>高品质焊接设备生产商</span>
          </p>
          <q>
            <em id="cursite">全国</em>服务热线：
            <b>021-65056515</b>
          </q>
        </div>
        <div class="h_nav">
          <ul>
            <li :class="cutid==1?'cur':'knone'">
              <router-link tag="a" :to="{name: 'home',params: { id: 1,nid:1 }}">
                <span>首页</span>
              </router-link>
            </li>
            <li :class="cutid==2?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'product', params: { id: 59,nid:2 }}">
                <span>管焊机</span>
              </router-link>
            </li>
            <li :class="cutid==11?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'product', params: { id: 64,nid:11 }}">
                <span>管道辅助工具</span>
              </router-link>
            </li>
            <li :class="cutid==3?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'product', params: { id: 62,nid:3 }}">
                <span>管板焊机</span>
              </router-link>
            </li>
            <li :class="cutid==4?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'product', params: { id: 63,nid:4 }}">
                <span>自动焊专机</span>
              </router-link>
            </li>
            <li :class="cutid==5?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
                <span>产品中心</span>
              </router-link>
            </li>
            <li :class="cutid==6?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'about', params: { id: 1,nid:6 }}">
                <span>焊机租赁</span>
              </router-link>
            </li>
            <li :class="cutid==7?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'about', params: { id: 2,nid:7 }}">
                <span>售后服务</span>
              </router-link>
            </li>
            <li :class="cutid==8?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'about', params: { id: 3,nid:8 }}">
                <span>公司简介</span>
              </router-link>
            </li>
            <li :class="cutid==9?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'about', params: { id: 4,nid:9 }}">
                <span>联系我们</span>
              </router-link>
            </li>
            <li class="nobor" :class="cutid==10?'cur':'knone'">
              <router-link tag="a" :to="{ name: 'about', params: { id: 5,nid:10 }}">
                <span>应用行业</span>
              </router-link>
            </li>
            <li class="nobor">
              <a href='http://v.qq.com/vplus/462bf82b56bfe1828cd6e6189ae90664?page=video' target="_blank">
                <span>演示视频</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { menuapi } from "@/utils/api"; //引入api至当前文件
export default {
  data() {
    return {
      logo: require("../../static/images/logo.jpg"),
      cutid: 1
    };
  },
  watch: {
    $route() {
      let nid = this.$route.params.nid ? this.$route.params.nid : 1;
      this.cutid = nid;
    }
  }
};
</script>

<style scoped>
</style>
